<app-widget [widget-meta]="this.data"
  class="widget-kudos"
  alertCount="{{( kudosService.newKudos$ | async)?.length}}"
  hidehelp="true">

  @if ({ new: kudosService.newKudos$ | async, accepted: acceptedKudos$ | async }; as data) {
    <div>
      <!-- TAB NAVIGATION-->
      <ul class="nav nav-tabs" role="tablist">
        @if (data.new?.length > 0) {
          <li class="nav-item">
            <a class="nav-link"  [ngClass]="{ 'active':data.new?.length > 0 }" href="#newKudos" data-bs-toggle="tab" role="tab"
            aria-controls="newKudos" aria-selected="true">New ({{data.new?.length}})</a>
          </li>
        }
        @if (data.accepted?.length > 0) {
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{ 'active':(data.new?.length == 0) }" href="#myKudos" data-bs-toggle="tab" role="tab"
            aria-controls="myKudos" aria-selected="false">My Kudos ({{data.accepted?.length}})</a>
          </li>
        }
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active':(data.new?.length == 0) && (data.accepted?.length == 0) }" href="#submitKudo" data-bs-toggle="tab" role="tab" aria-controls="submitKudo"
          aria-selected="false">Give Kudos</a>
        </li>
      </ul>
      <div class="tab-content row">
        <!-- NEW KUDOS TAB -->
        @if (data.new?.length > 0) {
          <div [ngClass]="{ 'active show':data.new?.length > 0 }" class="tab-pane fade w-100" id="newKudos" role="tabpanel">
            <div class="container">
              @for (item of data.new; track item) {
                <div class="row">
                  <div class="col-12">
                    <blockquote>
                      <span>{{item.Message}}</span>
                      <cite><i>{{item.SenderDisplayName}} (on {{item.SentOn | date : 'MMM d, y, h:mm a'}})</i></cite>
                      <button type="button" class="btn btn-sm btn-success" (click)="accept(item)">Accept</button>
                      <div class="divider"></div>
                      <button type="button" class="btn btn-sm btn-danger" (click)="reject(item)">Reject</button>
                      <button type="button" class="btn btn-sm btn-link float-end link-dark" (click)="report(item)">Report Abuse</button>
                    </blockquote>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        <!-- MY KUDOS TAB -->
        @if (data.accepted?.length > 0) {
          <div [ngClass]="{ 'active show':(data.new?.length == 0) }" class="tab-pane fade w-100" id="myKudos" role="tabpanel">
            <div class="container">
              @for (item of data.accepted; track item; let i = $index) {
                <div class="row">
                  @if (i < kudosToShow) {
                    <div class="col-12">
                      <blockquote>
                        <span>{{item.Message}}</span>
                        <cite><i>{{item.SenderDisplayName}} (on {{item.SentOn | date : 'MMM d, y, h:mm a'}})</i></cite>
                      </blockquote>
                    </div>
                  }
                </div>
              }
              @if (data.accepted.length > kudosToShow) {
                <button type="button" class="btn btn-link" (click)="isExpanded = !isExpanded"
                  [attr.aria-expanded]="isExpanded" aria-controls="collapsedKudos">
                  {{isExpanded ? "Hide" : "Show"}} {{ data.accepted.length - kudosToShow}} older kudos
                </button>
              }
              <div id="collapsedKudos"  [ngbCollapse]="!isExpanded" >
                @for (item of data.accepted; track item; let i = $index) {
                  <div class="row">
                    @if (i >= kudosToShow) {
                      <div class="col-12">
                        <blockquote>
                          <span>{{item.Message}}</span>
                          <cite><i>{{item.SenderDisplayName}} (on {{item.SentOn | date : 'MMM d, y, h:mm a'}})</i></cite>
                        </blockquote>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <!-- GIVE KUDOS TAB -->
        <div [ngClass]="{ 'active show':(data.new?.length == 0) && (data.accepted?.length == 0) }" class="tab-pane fade col-12" id="submitKudo" role="tabpanel">
          <div class="container row g-3">
            <fieldset>
              <div id='scrollable-dropdown' class="col-auto">
                <label for="kudo-person-lookup" class="form-label">Who earned the kudos?</label>
                <input #nameInput id="kudo-person-lookup" type="text" class="form-control"
                  placeholder="Type a few letters to search"
                  [editable]='false'
                  [(ngModel)]="model.recipient"
                  [ngbTypeahead]="search"
                  [resultFormatter]="lookupResultFormatter"
                  [inputFormatter]="lookupInputFormatter" />
                  @if (isSearching) {
                    <small class="form-text text-muted">searching...</small>
                  }
                  @if (searchFailed) {
                    <div class="invalid-feedback">Enter two or more characters to load suggestions.</div>
                  }
                </div>
                <div class="col-auto">
                  <label for="kudo-message" class="form-label">Say something nice: ({{280 - kudoMessage.value.length}} characters left)</label>
                  <textarea #kudoMessage id="kudo-message" type="text" class="form-control"
                    placeholder="You are awesome!"
                    maxlength="280"
                  [(ngModel)]="model.message"></textarea>
                </div>
                <div class="form-check mt-1">
                  <input type="checkbox" class="form-check-input" id="idAnon" [(ngModel)]="model.isAnon">
                  <label class="form-check-label" for="idAnon">Anonymous? <small>(Your name will be recorded, but the recipient won't see it.)</small></label>
                </div>
                <br/>
                <button class="btn btn-sm btn-primary"
                  [disabled] ="!(!!model.message && !!model.recipient?.PersonId)"
                (click)="sendKudo()">Send</button>
                <span class="font-weight-bold">&nbsp;{{sendMessage}}</span>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="widget-loading text-center">
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
    }

  </app-widget>
